import { render, staticRenderFns } from "./UsageView.vue?vue&type=template&id=70fa124e&scoped=true"
import script from "./UsageView.vue?vue&type=script&lang=js"
export * from "./UsageView.vue?vue&type=script&lang=js"
import style0 from "./UsageView.vue?vue&type=style&index=0&id=70fa124e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa124e",
  null
  
)

export default component.exports